import React from 'react';
import Spinner from '@atlaskit/spinner';
import styled from '@emotion/styled';

export const LoadingState = () => (
  <SpinnerWrapper>
    <Spinner size="large" />
  </SpinnerWrapper>
);

const SpinnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
